const NoMaskImagesModal = ({images, startOverNoMaskStep}) => {
  return (
    <div className="modal fade modal-dark" id="no_mask_images_modals" tabIndex="-1" aria-hidden="true">
        <div className="modal-dialog modal-dialog-scrollable modal-xl" role="document">
            <div className="modal-content">
            <div className="modal-header">
                <h5 className="modal-title">Images collectées — sans masque</h5>
                <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                ></button>
            </div>
            <div className="modal-body">
                <div className="row">
                    {images.map((img, index) =>
                        <div className="col-md-3 col-lg-3 mb-3" key={index}>
                            <div className="card h-100 card-dark">
                                <img className="card-img-top" src={img.url} alt="Card image cap" />
                                <div className="card-body">
                                    <div className="card-text text-center">Précisions</div>
                                    <p className="card-text" style={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.82rem' }}>Détection du visage : {img.faceConf}%</p>
                                    <p className="card-text" style={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.82rem' }}>Pas de masque : {(img.maskProbs[1] * 100).toFixed(2)}%</p>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <div className="modal-footer">
                <button type="button" className="btn btn-outline-light" data-bs-dismiss="modal">
                    Fermer
                </button>
                <button type="button" className="btn btn-outline-warning" data-bs-dismiss="modal" onClick={startOverNoMaskStep}>Recommencer</button>
            </div>
            </div>
        </div>
    </div>
  )
}

export default NoMaskImagesModal